<template>


	<section class="section-top-border relative">
		<lingo_toolbar_light></lingo_toolbar_light>


		<v-layout column wrap class="" align-center>

			<v-flex xs12 sm4 class="my-5">
				<h1 class="font-weight-thin display-2">Информация за Проект BG16RFOP002-2.024-0259</h1>
			</v-flex>


			<v-flex xs12 class="my-55">
				<v-container grid-list-xl>
					<v-layout row wrap align-center>




						<v-card class="elevation-0" width="900">
							<v-card-title class=" top-border-thin-1 mb-3">

							<div class="card card-emphasised pt-4 pl-4 pr-3 px-20 subheading">
							<img src="../../assets/euFlagBG.png" width="50%" style="vertical-align:middle"/>
							<img src="../../assets/programLogoBG.png" width="50%" style="vertical-align:middle"/>
							</div>


								<div class="card card-emphasised pt-4 pl-4 pr-3 px-20 subheading">
									<h2 id="introduction" class="blue--text font-weight-light">Проект</h2>
									 <p>На 10.06.2019 г. "ЛингоЕйВи" ООД стартира изпълнението на проект „Насърчаване на предприемачеството в “ЛИНГОЕЙВИ“ ООД чрез създаване на платформа за предоставяне на "текст-към-реч" съдържание за нуждите на телевизионната и кино–индустрията“. Проектът е финансиран от Оперативна програма „Иновации и конкурентоспособност“ 2014 – 2020, процедура BG16RFOP002-2.024 - Насърчаване на предприемачеството.
									</p>
									<h2 id="introduction" class="blue--text font-weight-light">Цели</h2>
									<p>
									Основна цел на проекта е да подкрепи новосъздадено предприятие, функциониращо в приоритетен сектор на Националната стратегия за насърчаване на малките и средните предприятия 2014-2020 г. – С 59 „Производство на филми и телeвизионни предавания, звукозаписване и издаване на музика“ и район с висока степен на безработица – гр. Монтана. Дейностите, предвидени в проекта, ще се изпълнят в рамките на код на икономическа дейност, 63.11 – „Обработка на данни, хостинг и подобни дейности“ и предвиждат комплекс от мерки за реализиране на предприемаческата идея - създаване на платформа за предоставяне на text-to-speech съдържание за нуждите на телевизионната и кино–индустрията.
									</p>
									<h2 id="introduction" class="blue--text font-weight-light">Дейности</h2>
									<p>
									Дейностите, заложени за изпълнение в проекта, включват реализиране на комплекс от мерки, водещи до създаване на платформа за предоставяне на text-to-speech съдържание за нуждите на телевизионната и кино–индустрията. Продуктите, които ще се реализират чрез платформата, са: Специализирана Текст-към-Реч услуга и Синтетичен дублаж.
									</p>
									<h2 id="introduction" class="blue--text font-weight-light">Продължителност</h2>
									<p>
									Проектът ще се изпълнява в рамките на 18 месеца в район, характерен с високи нива на безработица и нисък дял на инвестиции – гр. Монтана.
									</p>
									<h2 id="introduction" class="blue--text font-weight-light">Финансиране</h2>
									<p>
									<span style="display:block">Стойност на бюджета в лева: 249 887.42 лв</span>
									Финансиране от ЕС: 199 909.94 лв, в т.ч.
									<ul class="pb-1">
									<li>ЕФРР: 169 923.45 лв</li>
									<li>Национално финансиране: 29 986.49 лв</li>
									</ul>
									Собствено финансиране: 49 977.48 лв
									</p>
									<h2 id="introduction" class="blue--text font-weight-light">Обява</h2>
									<p>
										Във връзка с изпълнението на проект №BG16RFOP002-2.024-0259, "ЛингоЕйВи" ООД обявява процедура за избор на изпълнител за разработване на специализиран софтуер. Документацията за участие в процедурата, можете да изтеглите от <a href="Обява.rar" target="_blank">тук</a>.
									</p>
								</div>

							</v-card-title>
						</v-card>

					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>


		<lingo_footer_light class="mt-5"></lingo_footer_light>
	</section>







</template>

<script>
	import lingo_toolbar_light from './ToolbarLight';
	import lingo_footer_light from './FooterLight';

	export default {
	name: "euProgramDetails",
	data() {
	return {

	};
	},
	components: {
	lingo_toolbar_light,
	lingo_footer_light
	}
	};
</script>
